import React, { useState } from "react";

import "./AssessmentSideDrawer.scss";
import Physio from "../../../organisms/Progress/Physio/Physio";
import Tabs from "../../../atoms/Tabs/Tabs";
import AssessmentWrapper from "../AssessmentWrapper/AssessmentWrapper";
import AssessmentAISummary from "../../AssessmentAISummary";
import AIGeneratedDietPlan from "../../AIGeneratedDietPlan";

const AssessmentSideDrawer: React.FC<{ 
  onAutofill?: (dietPlanData: any) => void;
  onCloseToIndex?: () => void;
}> = ({ onAutofill, onCloseToIndex }) => {
  const tabs = [
    {
      label: "Goals",
      value: "GOALS",
    },
    {
      label: "Assessment",
      value: "ASSESSMENT",
    },
    // Temporarily hiding tab as it's product requirement.
    // {
    //   label: "Assessment Summary",
    //   value: "ASSESSMENT_SUMMARY",
    // },
    {
      label: "AI Generated Diet Plan",
      value: "AI_GENERATED_DIET_PLAN",
    },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0].value);

  return (
    <div className="assessment-side-drawer">
      <div className="tabs-container">
        <Tabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />
      </div>
      <div className="tabs-content">
        {activeTab === "ASSESSMENT" ? (
          <AssessmentWrapper />
        ) : activeTab === "GOALS" ? (
          <Physio mode="view" />
        ) : activeTab === "ASSESSMENT_SUMMARY" ? (
          <AssessmentAISummary />
        ) : activeTab === "AI_GENERATED_DIET_PLAN" ? (
          <AIGeneratedDietPlan onAutofill={onAutofill} onCloseToIndex={onCloseToIndex} />
        ) : null}
      </div>
    </div>
  );
};

export default AssessmentSideDrawer;
